<template>
  <div class="cdkey-list" v-if="cdKeyInfoList && cdKeyInfoList.length">
    <div class="cdkey-item" v-for="(item, index) in cdKeyInfoList" :key="index">
      <div class="cdkey-box" v-for="(cou, idx) in item.couponNum" :key="cou">
        <div class="row" v-if="cou">
          <div class="title">{{ `卡号${index + 1}` }}</div>
          <div class="value">
            {{ cou }}
            <v-button class="btn-copy" size="small" lineColor="#E8E8E8" color="rgba(0, 0, 0, 0.95)" type="frame"
              @click="copyContent(cou)">
              复制
            </v-button>
          </div>
        </div>
        <div class="row" v-if="item.couponCode[idx]">
          <div class="title">{{ `卡密${index + 1}` }}</div>
          <div class="value">
            {{ item.couponCode[idx] }}
            <v-button class="btn-copy" size="small" lineColor="#E8E8E8" color="rgba(0, 0, 0, 0.95)" type="frame"
              @click="copyContent(item.couponCode[idx])">
              复制
            </v-button>
          </div>
        </div>
      </div>
      <div class="border1px"></div>
      <div class="row">
        <div class="title">使用说明</div>
        <a class="btn-use" :href="item.applyLink">立即使用<i class="arrow-right"></i></a>
      </div>
      <div class="explain" v-html="item.applyExplain"></div>
    </div>
  </div>
</template>

<script>
import app from 'utils/app'
export default {
  name: 'ProductCDKeyList',
  props: {
    cdKeyInfoList: {
      type: Array,
      default: []
    }
  },
  methods: {
    copyContent (content) {
      app.copyContent(content, () => {
        this.$toast('已复制')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.cdkey-item {
  margin: 30px 48px 0 48px;
  background: #fafafa;
  border-radius: 18px;
  padding: 36px;
  .row {
    display: flex;
    position: relative;
    justify-content: space-between;
    align-items: center;
    &:nth-child(n + 2) {
      padding-top: 48px;
    }
    .title {
      width: 210px;
      font-size: 36px;
      line-height: 45px;
      color: rgba(0, 0, 0, 0.84);
      flex-shrink: 0;
      @include os-font-weight(36, 40);
    }
    .value {
      font-size: 36px;
      color: rgba(0, 0, 0, 0.95);
      line-height: 45px;
      @include os-font-weight(36, 50);
      display: flex;
      align-items: baseline;
      .btn-copy {
        margin-left: 21px;
      }
    }
    .btn-use {
      font-size: 36px;
      @include os-font-weight(36, 40);
      color: #f10313;
      line-height: 45px;
      display: flex;
      .arrow-right {
        background: url(./images/arrow-right.png) no-repeat;
        background-size: contain;
        width: 18px;
        height: 45px;
        display: inline-block;
        margin-left: 9px;
      }
    }
  }
  .border1px {
    margin-top: 53px;
    margin-bottom: 48px;
    @include border1px(0010, rgba(222, 222, 222, 1));
  }
  .explain {
    margin-top: 30px;
    font-size: 36px;
    color: #999;
    line-height: 45px;
    white-space: break-spaces;
  }
}
</style>